import React from 'react'
import get from 'lodash/get'
import moment from 'moment'
import styled from 'styled-components'
import StyledCheckbox from '../checkbox/StyledCheckbox'

interface Column {
  content?: (item: any, contentLoading?: boolean) => React.ReactNode
  path?: string
  key?: string
  alignBody?: string
}

interface TableBodyProps {
  data?: any[]
  columns?: Column[]
  selectedRows?: any[]
  checkBox?: boolean
  tableRef?: React.Ref<any>
  loading?: boolean
  contentLoading?: boolean
  handleRowClick?: (item: any) => void
  setSelectedRows?: (rows: any[]) => void
}

const TableBody: React.FC<TableBodyProps> = ({
  data,
  columns,
  selectedRows,
  checkBox,
  tableRef,
  loading,
  contentLoading = false,
  handleRowClick,
  setSelectedRows,
}) => {
  const renderCell = (item: any, column: Column) => {
    if (column.content) return column.content(item, contentLoading)
    if (column.path === 'createdAt' || column.path === 'updatedAt') {
      return formatDate(get(item, column.path))
    }
    return get(item, column.path ?? '', '-') ?? '-'
  }

  const createKey = (item: any, column: Column) => {
    // return (item?.id || 1) + (column?.path || column?.key) + Math.random();
    return `${item.id}-${column.content || column.path}`
  }
  const formatDate = (date: any) => moment(new Date(date)).format('Do MMM YYYY')
  const totalRows = data?.length ?? 0 // Check if the row is the last one
  return (
    <StyledTBody ref={tableRef}>
      {data?.map((item, index) => (
        <tr
          key={`row-${index}`}
          ref={tableRef}
        >
          {checkBox && (
            <td ref={tableRef} className='align-middle'>
              <StyledCheckbox
                className={`ms-2 mt-2 me-2 ${
                  item?.GDPRDeleted || item._source?.candidateStatus === 44 ? 'pe-none' : ''
                }`}
                size={15}
                value={selectedRows?.includes(item)}
                onChange={() => {
                  handleRowClick && handleRowClick(item)
                }}
              />
            </td>
          )}

          {columns?.map((column, colIndex) => {
            const isFirstColumn = colIndex === 0 && !checkBox
            const isFirstColumnWithCheckbox = colIndex === 1 && checkBox
            const shouldBeClickable = isFirstColumn || isFirstColumnWithCheckbox
            
            return (
              <td
                key={createKey(item, column)}
                className={`${column.alignBody} ${index >= totalRows - 3 ? 'last-row' : ''} fw-normal ${
                  shouldBeClickable ? 'table-code-link' : ''
                }`}
              >
                {renderCell(item, column)}
              </td>
            )
          })}
        </tr>
      ))}
    </StyledTBody>
  )
}

const StyledTBody = styled.tbody`
  overflow-y: auto;
  tr:last-child > td {
    border-bottom: 0;
  }
`

export default TableBody
